var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFullRightArrowDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29 0.79006C5.19627 0.883023 5.12188 0.993623 5.07111 1.11548C5.02034 1.23734 4.9942 1.36805 4.9942 1.50006C4.9942 1.63207 5.02034 1.76278 5.07111 1.88464C5.12188 2.0065 5.19627 2.11709 5.29 2.21006L8.59 5.50006L1 5.50006C0.734784 5.50006 0.48043 5.60542 0.292893 5.79295C0.105357 5.98049 0 6.23484 0 6.50006C0 6.76528 0.105357 7.01963 0.292893 7.20717C0.48043 7.3947 0.734784 7.50006 1 7.50006L8.59 7.50006L5.29 10.7901C5.1017 10.9784 4.99591 11.2338 4.99591 11.5001C4.99591 11.7664 5.1017 12.0218 5.29 12.2101C5.4783 12.3984 5.7337 12.5042 6 12.5042C6.2663 12.5042 6.5217 12.3984 6.71 12.2101L11.71 7.21006C11.801 7.11495 11.8724 7.00281 11.92 6.88006C11.9729 6.76036 12.0002 6.63093 12.0002 6.50006C12.0002 6.36919 11.9729 6.23976 11.92 6.12006C11.8724 5.99731 11.801 5.88516 11.71 5.79006L6.71 0.79006C6.61704 0.696332 6.50644 0.621936 6.38458 0.571167C6.26272 0.520398 6.13201 0.494261 6 0.494261C5.86799 0.494261 5.73728 0.520398 5.61542 0.571167C5.49356 0.621936 5.38296 0.696332 5.29 0.79006Z",
    fill: "#2C303B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullRightArrowDark);
export default __webpack_public_path__ + "static/media/full-right-arrow-dark.4394a404b9af98faea3f71f304ef4b31.svg";
export { ForwardRef as ReactComponent };